import _ from 'lodash'

import CryptoJS from 'crypto-js'
export function createOptionSerial(id) {
    let e = id
    const Man = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'N',
        'W',
        'X',
        'Y',
        'Z',
    ];
    if (e < 25) {
        return Man[e];
    } else {
        const index = parseInt(e, 25);
        return Man[index] + Man[e - index * 25].toLowerCase();
    }
}

export function getMaxId(list_ = null){
    let maxId = 0
    const list = list_
    if (list && list.length) {
        let ids = list.map(item => item.id)
        ids = _.compact(ids)
        const tempMax = Math.max.apply(null, ids)
        if (tempMax && tempMax !== -Infinity) {
            maxId = tempMax
        }
    }
    return maxId
}

// 递归获取数组id
export function lookForAllId(data = [], arr = []) {
    for (let item of data) {
        arr.push(item.id)
        if (item.children && item.children.length) this.lookForAllId(item.children, arr)
    }
    return arr
}

export function randomUUID() {
    return crypto.randomUUID().replaceAll('-','');
}
